import {Component, input, output} from '@angular/core';

@Component({
  selector: 'confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.css'],
  standalone: false
})
export class ConfirmModalComponent {
  headerText = input<string>('Do you confirm?');
  confirmText = input<string>('Confirm');
  confirmColor = input<string>('#1F6D5F');
  confirm = output();
  cancel = output();

  onConfirm() {
    this.confirm.emit();
  }

  onCancel() {
    this.cancel.emit();
  }
}
